<app-ion-common-header [id]="headerId" (backHeader)="backPage()" close="true" (focusHeader)="shownContent();">
</app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">

  <div class="img-label-content">
    <img class="img-button approved-icon" src="../../../assets/images/svg/broker-registration-icon.svg" alt="icon"
      aria-hidden="true">
  </div>

  <div class="conent-center conent-center--ph-0 center-info text-rg">
    <h1>Atualização de cadastro e uso do app</h1>
    <div>
      <p>Ao continuar será necessário conferir se seus dados estão atualizados. 
        Iremos criar seu relacionamento com a Itaú Corretora e assim você pode investir 
        em todos os produtos disponíveis no app.
      </p>
      <p>Esse processo é simples, rápido e gratuito.</p>
    </div>
  </div>

  <app-ion-common-button label="Continuar" typeButton="dark" positionButton="fixed" (clickButton)="clickNext()">
  </app-ion-common-button>

</ion-content>